import React from 'react';
import { formatAffairAmount } from '../../affairs/affairFormatters';
import PartnerRelatedItemsTable from './PartnerRelatedItemsTable';

const columns = [
  { key: 'number', label: 'Numéro', render: (row) => row.quoteNumber || row.quote_number || '—' },
  { key: 'title', label: 'Titre', render: (row) => row.title || '—' },
  { key: 'type', label: 'Type', render: (row) => row.quoteType || row.quote_type || '—' },
  { key: 'status', label: 'Statut du devis', render: (row) => row.status || '—' },
  { key: 'amount', label: 'Montant', render: (row) => formatAffairAmount(row.totalClientAmount || row.total_client_amount || row.totalAmount) },
  { key: 'affair', label: 'Affaire liée', render: (row) => row.affairCode || row.affair_code || row.affairId || row.affair_id || '—' },
];

export default function PartnerQuotesPanel({ rows, onNavigate }) {
  return <section className="partner-section"><PartnerRelatedItemsTable rows={rows} columns={columns} onOpen={(row) => onNavigate(`/Devis?quoteId=${row.id}`)} emptyMessage="Aucun devis lié." /></section>;
}
